import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
import { ReactComponent as RefreshIcon } from "../../assets/images/RefreshIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  CLIENT_ID,
  REDIRECT_URI,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import styles from "./EnvironmentPage.module.css";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import TopBar from "../../components/topbar/TopBar";
import { getAllEnvironment } from "../../reduxSlices/environmentSlice";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { toast } from "react-toastify";
import { Service } from "../../services/service";
import CommonDialog from "../../components/dialog/CommonDialog";
import ButtonCta1 from "../../components/button/ButtonCta1";
import { Typography } from "@mui/material";
import CustomTooltip from "../../components/tooltip/CustomTooltip";
import NoResultFound from "../../components/noResultFound/NoResultFound";
import { getUserLogin } from "../../reduxSlices/userSlice";

const service = new Service();

const columns = [
  {
    id: "organisationName",
    label: "Organisation Name",
    minWidth: 170,
    align: "left",
  },
  {
    id: "environmentId",
    label: "Environment Id",
    minWidth: 170,
    align: "left",
  },
  {
    id: "environmentName",
    label: "Environment Name",
    minWidth: 170,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    align: "left",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

export default function EnvironmentPage() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("");
  const allEnvironment = useSelector(
    (state) => state.environment.allEnvironment
  );
  const loading = useSelector((state) => state.environment.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const userEmailId = userData?.emailId;
  const environment_id = userData?.environmentId && userData?.environmentId[0];
  const organisationId = userData?.organisationId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);

  const client_id = CLIENT_ID;
  const redirectUri = REDIRECT_URI;

  const connectClick = () => {
    localStorage.setItem("isConnect", true);
    localStorage.setItem("environment_id", environment_id);
    const url = `https://app.blackbaud.com/oauth/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&environment_id=${environment_id}`;
    window.open(url, `_self`);
  };

  const handleMoreIcon = (event, item) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setId(item?.environmentId);
    setData(item);
  };

  const getEnvironmentData = async () => {
    const obj = {
      organizationId: !isVfAdmin ? organisationId : "",
      searchText: searchInput || "",
    };
    await dispatch(getAllEnvironment(obj));
  };

  const fetchUserLogin = async () => {
    const obj = {
      email: userEmailId,
    };
    await dispatch(getUserLogin(obj));
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "environments",
        title: "Environments",
        subTitle:
          "Here is the list of all environments along with their details",
      })
    );
  }, []);

  useEffect(() => {
    getEnvironmentData();
  }, [dispatch]);

  const getOrganisationDataWithDebounce = debounce(() => {
    getEnvironmentData();
  }, 500);

  const searchInputDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (id) {
      console.log("id>>>>>>>", id);
      deleteEnvironment(id);
      setOpen(false);
    }
  };

  const deleteEnvironment = async (id) => {
    let url = `/api/Environment/DeleteEnvironment?id=${id}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.newDeleteApi(url, {}, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success(
          `Environment marked as ${data?.isActive ? "Inactive" : "Active"}`,
          {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          }
        );
        getEnvironmentData();
        fetchUserLogin();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar
          isVfAdmin={isVfAdmin}
          clearFilter = {false}
          placeholder="Search environments here..."
        />
        {loading && allEnvironment.length <= 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{ maxHeight: "calc(100vh - 320px)", padding: "0 0" }}
            className="table_container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#fff",
                        color: "#8a8a8a",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allEnvironment.length > 0 ? (
                  <>
                    {allEnvironment?.map((elem) => (
                      <TableRow hover key={elem.environmentId}>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#282828",
                            fontWeight: 600,
                          }}
                        >
                          {elem?.organization?.organizationName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.environmentId || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.environmentName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.isActive ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            cursor: isVfAdmin ? "pointer" : "",
                          }}
                          align="center"
                        >
                          {isVfAdmin ? (
                            <MoreIcon
                              onClick={(e) => handleMoreIcon(e, elem)}
                            />
                          ) : (
                            <>
                              {elem?.isValidToken ? (
                                <>
                                  <Typography
                                    sx={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      fontFamily: "Montserrat",
                                      color: "#8a8a8a",
                                    }}
                                  >
                                    Connected
                                  </Typography>
                                  <CustomTooltip
                                    title={"Refresh Token."}
                                    placement="bottom"
                                  >
                                    <RefreshIcon
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "12px",
                                      }}
                                      onClick={() => connectClick()}
                                    />
                                  </CustomTooltip>
                                </>
                              ) : (
                                <ButtonCta1
                                  text="Connect"
                                  onClick={() => connectClick()}
                                  variant="text"
                                  disabled={false}
                                  width="auto"
                                  height="20px"
                                  color="#f7954c"
                                />
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    <ActionDropdown
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      editNavigate={`/edit-environment/${id}`}
                      setOpen={setOpen}
                      isDelete={false}
                      isActive={true}
                      text={`Mark as ${data?.isActive ? "Inactive" : "Active"}`}
                      markAsActiveInactive={handleDelete}
                    />
                  </>
                ) : (
                  <NoResultFound
                    description="We couldn’t find any matches for search query or applied filter. Please try different
                  keyword or filters."
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle={`Are you sure you want to delete <span style="font-weight: 700;">${data?.environmentName}</span> as an environment? You’ll not be able to reverse this action.`}
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
    </>
  );
}
